import Icon from '@mui/icons-material/Business';

import { ListEPG } from './ListEPG';

export const EPGResourceConfig = {
  list: ListEPG,
  icon: Icon,
  name: 'epg',
};
